import { render, staticRenderFns } from "./SimplifiedOnboardingModal.vue?vue&type=template&id=5ac336cc&scoped=true"
import script from "./SimplifiedOnboardingModal.vue?vue&type=script&lang=js"
export * from "./SimplifiedOnboardingModal.vue?vue&type=script&lang=js"
import style0 from "./SimplifiedOnboardingModal.vue?vue&type=style&index=0&id=5ac336cc&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac336cc",
  null
  
)

export default component.exports